import { Suspense, lazy, useEffect } from "react";
import ErrorBoundary from "ErrorBoundary";
import LazyLoading from "Utils/LazyLoading";
import Toast from "Utils/Toast";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
  const AppRouter = lazy(() => import("Routes/Index"));

  useEffect(() => {
    const handleOnline = () => {
      Toast("s", "Internet connection restored!", "top-center");
    };
    const handleOffline = () => {
      Toast("w", "Internet connection lost!", "top-center");
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      }
    };
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Prime Pet Admin</title>
        {typeof window !== 'undefined' && (
          <link rel="canonical" href={window.location.origin} />
        )}
        <meta name="description" content="Prime Pet Admin" />
      </Helmet>
      <Suspense fallback={<LazyLoading />}>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
